import { Overmind } from 'overmind';
import { Context } from './index';

export const onInitializeOvermind: (context: Context, instance: Overmind<Context>) => void = (
  context: Context,
  instance: Overmind<Context>,
) => {
  // TODO: only save the jwt, not the full user - and move to auth, not session
  // context.actions.session.setCurrentUserFromStorage();
  // context.actions.auth.setJwt(context.state.session.sessionData.accessToken); // TODO: remove it from session
  // context.actions.auth.setReported(true);
};
